import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom';
import Header from '../common/Header';
import Footer from '../common/Footer';
import { getAllKendraCount } from '../../hooks/services/api-services';

const UserLayout = () => {
   

    const [kendraCount, setkendraCount] = useState(0)
    // const getAllKendraCount= async() =>{
    //     try {
    //         const response = await getAllKendraCount();
    //         if (response?.status == 200) {
    //             setkendraCount(response?.data?.responseBody?.data);
    //         } 
    //       } catch (err) {
    //       }
    // }
    // useEffect(async() => {
    //     getAllKendraCount();
    // }, [])
    
    return (
        <>
            <Header/>
            <Outlet />
            <Footer />
        </>
    )
}

export default UserLayout;
